import StringHelpers from './helpers';
var pattern = StringHelpers.pattern;
export default function formatDynamic(target, fn) {
    var index = 0;
    return (target || '').replace(pattern, function (match, parm) {
        return fn(parm, index++);
    });
}
//# sourceMappingURL=format-dynamic.js.map